/**
 * A simplified footer component for landing pages
 * Contains only essential legal links
 */
import {
  HEALTHMATCH_CONSUMER_HEALTH_DATA_URL,
  HEALTHMATCH_PRIVACY_URL,
  HEALTHMATCH_TERMS_URL,
} from "../utils/urlConfig";

export function LandingPageFooter() {
  return (
    <footer className="bg-white py-6 border-t border-gray-100">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-center items-center space-y-2 sm:space-y-0 sm:space-x-6">
          <a
            href={HEALTHMATCH_PRIVACY_URL}
            className="text-xs text-gray-500 hover:text-gray-700"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          <a
            href={HEALTHMATCH_CONSUMER_HEALTH_DATA_URL}
            className="text-xs text-gray-500 hover:text-gray-700"
            target="_blank"
            rel="noopener noreferrer"
          >
            Consumer Health Data Privacy
          </a>
          <a
            href={HEALTHMATCH_TERMS_URL}
            className="text-xs text-gray-500 hover:text-gray-700"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms & Conditions
          </a>
          <p className="text-xs text-gray-400">
            © {new Date().getFullYear()} HealthMatch.io. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
